module.exports = __webpack_public_path__ + "img/contact-item1.062adafe.png";